<template>
  <router-view/>
</template>

<script>
export default {
  name: 'PageIndex'
}
</script>
